import { render, staticRenderFns } from "./bidWinAnnouncementDetail.vue?vue&type=template&id=ad2b8b3c&scoped=true"
import script from "./bidWinAnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./bidWinAnnouncementDetail.vue?vue&type=script&lang=js"
import style0 from "./bidWinAnnouncementDetail.vue?vue&type=style&index=0&id=ad2b8b3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b8b3c",
  null
  
)

export default component.exports